import { withPrefix } from 'gatsby'

export default {
  metadata: {
    title: 'Work with us to shape the future of insurance technology. - artificial',
    desc: 'We’re hiring creative and ambitious problem-solvers to help us revolutionise the insurance industry. Why not join us?',
  },
  ArHeroHeader: {
    background: {
      url: withPrefix('img/ArHeroHeaderCompanyCareers.jpg'),
    },
    title: 'Careers',
    description: "We're building a team that's shaping the future of the insurance industry.",
    cta: {
      label: 'Open positions',
      onClick: {
        action: 'scrollToElement',
        id: '#job-propositions',
        offsetTop: -100,
      },
    },
  },
  ArTextWithImageStacked: {
    items: [
      {
        title: 'Our values',
        description: [
          'At Artificial, we invest in those who invest in themselves. Our team is made up of self-starters and ambitious team-players; egoless self-assessment and iterative improvement are at the core of every member of staff.',
          { tag: 'br' },
          { tag: 'br' },
          'If you share these values and want to work with like-minded people in a relaxed but driven environment, where you are given the tools and responsibility you need, our team could be the right fit.',
          { tag: 'br' },
          { tag: 'br' },
          'We’re hiring creative and ambitious problem-solvers to help us revolutionise the insurance industry. Why not join us?',
        ],
        images: [
          { url: withPrefix('img/ArTextWithImage15b.png') },
          { url: withPrefix('img/ArTextWithImage15b.png') },
          { url: withPrefix('img/ArTextWithImage15c.png') },
        ],
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scComponentMargins: {
          top: ['40px', '80px', '100px'],
          bottom: ['40px', '80px', '100px'],
        },
        scImageMargins: {
          right: ['0', '0', '0'],
          bottom: ['0', '0', '0'],
          top: ['0', '40px', '0'],
          left: ['0', '0', '0'],
        },
        scInverseStack: true,
        scDescMaxWidth: [null, '640px', null],
        scDesktopGap: 140,
        scImageWidthOnDesktop: '48.4%',
      },
    ],
  },
  ArBenefits: {
    title: 'Why should you join Artificial?',
    description: 'We offer many perks and benefits - here are just a few.',
    benefits: [
      {
        image: {
          url: withPrefix('img/ArCareerBenefits1.png'),
        },
        title: 'Remote friendly',
        description: 'We don’t restrict ourselves to one place - we are relatively location agnostic, provided timezones cross over with London working hours.',
      },
      {
        image: {
          url: withPrefix('img/ArCareerBenefits2.png'),
        },
        title: 'Fantastic culture',
        description: ' We pride ourselves on the culture within our team. Team satisfaction was voted 8.7/10 in a recent internal poll, and we’re always striving to improve. ',
      },
      {
        image: {
          url: withPrefix('img/ArCareerBenefits3.png'),
        },
        title: 'Generous holidays',
        description: 'We have great holiday allowances: 28 days per year plus bank holidays, and we don’t work between Christmas and New Year.',
      },
      {
        image: {
          url: withPrefix('img/ArCareerBenefits4.png'),
        },
        title: 'Equipment budget',
        description: 'We believe the best employees deserve the best tools, so we pay for you to have the best equipment.',
      },
      {
        image: {
          url: withPrefix('img/ArCareerBenefits5.png'),
        },
        title: 'Flexible hours',
        description: 'Not all of our team works 9-5. Whether you’re a night owl or an early riser, we know flexibility is important.',
      },
      {
        image: {
          url: withPrefix('img/ArCareerBenefits6.png'),
        },
        title: 'Conference and learning',
        description: 'If you see an interesting book, conference or course you’d like to go on - tell us! We encourage learning and development.',
      },
    ],
  },
  ArJobsListing: {
    title: 'Open positions',
    description: 'Looking for a new opportunity? View our current openings below.',
  },
}
